export default __webpack_public_path__ + "static/media/handgun.c2889959.png";